export default {
  state: {
    dataList: [
      // {
      //   name: "崔雪波",
      //   text: "崔雪波，男，山西转型综合改革示范区党工委委员、管委会副主任，山西转型综合改革示范区晋中开发区党工委书记、管委会主任。",
      //   tags: ["数字化改造", "网络化改造"],
      //   img: require("@/assets/images/home/panel_e_d_01.png"),
      //   authenticated: true,
      // },
      // {
      //   name: "周斌",
      //   text: "周斌，男，现任：山西转型综合改革示范区管委会副主任，博士，研究员，国家级重点实验室副总工、学术带头人，国防科技优秀中青年，中国电子学会优秀科技工作者。获省部级科技进步一等奖1项、二等奖4项，国防科技创新团队奖和中国电子信息科技创新团队奖各1项，发表SCI/EI论文51篇，授权发明专利22项，出版专著3本，编制标准4项，获软件著作权3项",
      //   tags: ["数字化改造", "网络化改造"],
      //   img: require("@/assets/images/home/panel_e_d_02.png"),
      //   authenticated: true,
      // },
      // {
      //   name: "郑文",
      //   text: "郑文，男，博士，教授，博士生导师。2018年作为“高层次引进人才”引进到太原理工大学大数据学院。山西省“三晋英才”青年优秀人才，担任山西省通信学会理事，山西省网络安全和大数据信息技术标准化技术委员会委员，山西云时代技术有限公司技术委员会委员。",
      //   tags: ["数字化改造", "网络化改造"],
      //   img: "",
      //   authenticated: false,
      // }
    ],
  },
};
